module.exports = __webpack_public_path__ + "img/sellway-img.e44b5614.png";